module.exports = __webpack_public_path__ + "media/images/weather/103_day-48fc17d03357f8f3bd8919e39715bf8f.png";